import '../css/admin_css.scss';

import { setDateTimeLocalization } from '@racemap/utilities/functions/datetime';
import { enableMapSet } from 'immer';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// makes the use of Map and Set in immer.js possible
enableMapSet();

setDateTimeLocalization();

const container = document.getElementById('root');
if (container == null) throw new Error('Could not find root element');

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
